<template>
  <div class="title" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <div class="title-content" :style="{
      'color': data.conStyle.titleColor,
      'font-size': `${data.conStyle.titleSize}px`,
      'font-weight': data.conStyle.titleBold === '是' ? 'bold' : 'normal',
      'text-align': data.conStyle.titleAlign === '居左' ? 'left' : 'center'
    }">{{ data.title }}
      <span class="more" v-if="data.conStyle.moreType !== '无'" :style="{
        'color': data.conStyle.moreColor
      }">
        <span v-if="data.conStyle.moreType !== '图标'">{{ data.conStyle.moreText }}</span>
        <i v-if="data.conStyle.moreType !== '文字'" class="el-icon-arrow-right"></i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TitlePreview',
  props: {
    data: Object
  }
}
</script>
<style scoped>
.title {
  font-size: 14px;
  /* padding: 15px 0 5px 15px; */
  background-color: #eff2f7;
  font-weight: normal;
  color: #666;
}
.title-content {
  position: relative;
}
.more {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/title/TitlePreview.vue